import { useTranslation } from 'react-i18next'
import { Box, Button, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { ROUTE } from 'navigation/types'

export const NeedsInformation = () => {
  const { t } = useTranslation('impact/NeedsInformation')

  return (
    <Stack direction="row" data-testid="onboarding-needs-information" justifyContent="center">
      <Stack spacing={1} sx={{ maxWidth: 550 }} alignItems="center">
        <Typography variant="h5">{t('title')}</Typography>

        <Typography>{t('body')}</Typography>

        <Box>
          <Button
            sx={{ marginTop: 2 }}
            variant="contained"
            component={Link}
            to={ROUTE.PROFILE_FIELDS}
          >
            {t('cta')}
          </Button>
        </Box>
      </Stack>
    </Stack>
  )
}
